import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ModuleEnum } from '../_utils/unums/module.enum';

export class Intent {
  //_id: number;
  phrases: string[];
  responses: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ServerService {
  ///endpoint = 'http://localhost:3001';
  endpoint = environment.server;
  firebase = environment.firebaseFunctionUrl;

  httpOptions = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  //// P2P MATCH ////
  matchUserP2Psimulation(data): Observable<any> {
    return this.http.post(`${this.firebase}/matchUsers`, data, this.httpOptions).pipe(catchError(this.handleError<Intent>('Error occured')));
  }

  sendEmailRescheduleSimulation(data): Observable<any> {
    return this.http.post(`${this.firebase}/sendRescheduleMail`, data, this.httpOptions).pipe(catchError(this.handleError<Intent>('Error occured')));
  }

  //// P2P Schedule ////
  sendRolePlaySelection(data): Observable<any> {
    return this.http.post<Intent>(`${this.endpoint}/peers/notify`, JSON.stringify(data), this.httpOptions).pipe(catchError(this.handleError<Intent>('Error occured')));
  }

  scheduleRolePlay(intent: Intent): Observable<any> {
    return this.http.post<Intent>(`${this.endpoint}/dialogflow/intent`, JSON.stringify(intent), this.httpOptions).pipe(catchError(this.handleError<Intent>('Error occured')));
  }

  //// Avatar Evaluation ////
  public getSimulationEvaluation(messages: any, metadata: any): Observable<any> {
    const url = `${this.endpoint}/simulation/evaluation`;
    return this.http.post(url, { messages, metadata }, { responseType: 'json' });
  }

  public getSimulationScoring(messages: any, metadata: any): Observable<any> {
    const url = `${this.endpoint}/simulation/scoring`;
    return this.http.post(url, { messages, metadata }, { responseType: 'json' });
  }

  //// Avatar Recording ////
  public generateAvatarRecord(body: { video: string; audio: string; fileAlias: string }): Observable<string> {
    const url = `${this.endpoint}/avatar-record`;
    return this.http.post(url, body, { responseType: 'text' });
  }

  public compressVideo(body: { video: string; fileAlias: string }): Observable<string> {
    const url = `${this.endpoint}/avatar-record/compress`;
    return this.http.post(url, body, { responseType: 'text' });
  }

  //// Intents ////
  createIntent(intent: Intent): Observable<any> {
    return this.http.post<Intent>(`${this.endpoint}/dialogflow/intent`, JSON.stringify(intent), this.httpOptions).pipe(catchError(this.handleError<Intent>('Error occured')));
  }

  getIntent(id): Observable<Intent[]> {
    return this.http.get<Intent[]>(this.endpoint + '/dialogflow/intent/' + id).pipe(
      tap((_) => console.log(`Intent fetched: ${id}`)),
      catchError(this.handleError<Intent[]>(`Get intent id=${id}`))
    );
  }

  getIntents(): Observable<Intent[]> {
    return this.http.get<Intent[]>(this.endpoint).pipe(
      tap((intents) => console.log('Intents retrieved!')),
      catchError(this.handleError<Intent[]>('Get intent', []))
    );
  }

  updateIntent(id, intent: Intent): Observable<any> {
    return this.http.put(this.endpoint + '/' + id, JSON.stringify(intent), this.httpOptions).pipe(
      tap((_) => console.log(`Intent updated: ${id}`)),
      catchError(this.handleError<Intent[]>('Update intent'))
    );
  }

  deleteIntent(id): Observable<Intent[]> {
    return this.http.delete<Intent[]>(this.endpoint + '/' + id, this.httpOptions).pipe(
      tap((_) => console.log(`Intent deleted: ${id}`)),
      catchError(this.handleError<Intent[]>('Delete intent'))
    );
  }
  //// END Intents ////

  public generateFinishModuleCertificate(body: { module: ModuleEnum; userFullName: string; date: string; fileName: string; lang: string }): Observable<any> {
    const url = `${this.endpoint}/pdf/finish-module-certificate`;
    // const url = `http://localhost:3001/pdf/finish-module-certificate`;
    return this.http.post<any>(url, body);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  public async checkAudioInput() {
    let errorMessage = '';
    let audioInputAvailable = false;

    try {
      // Check for media devices support
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        errorMessage = 'Media devices API not supported.';
        return { success: false, errorMessage };
      }

      // Get the list of media devices
      const devices = await navigator.mediaDevices.enumerateDevices();

      // Filter the list to get audio input devices (microphones)
      const audioInputs = devices.filter(device => device.kind === 'audioinput');

      // Check if there is at least one audio input device available
      audioInputAvailable = audioInputs.length > 0;

      if (!audioInputAvailable) {
        errorMessage = 'No audio input devices found.';
        return { success: false, errorMessage };
      }

      return { success: true };

    } catch (error) {
      audioInputAvailable = false;
      errorMessage = 'Error accessing media devices: ' + error.message;
      return { success: false, errorMessage };
    }
  }
}
